import assetUrl from 'src/common/utils/assetUrl';

export default function getPlayedProgressSvgPath(playedStatus) {
  const playedProgressSvgFileMap = {
    newPlaybackItem: 'play-button-0-v3.svg',
    playedProgress1: 'play-button-25-v3.svg',
    playedProgress2: 'play-button-50-v3.svg',
    playedProgress3: 'play-button-75-v3.svg',
    playedProgress4: 'play-button-97-v3.svg',
    completedPlaybackItem: 'play-button-100-v3.svg',
  };
  const filename =
    playedProgressSvgFileMap[playedStatus] || 'play-button-0-v3.svg';

  return assetUrl(`assets/img/playProgress/${filename}`);
}
